import { configureStore } from "@reduxjs/toolkit";
import filterReducer from "./slices/filterSlice";
import recordReducer from "./slices/recordSlice";
import sessionReducer from "./slices/sessionSlice";

const store = configureStore({
  reducer: {
    filter: filterReducer,
    record: recordReducer,
    session: sessionReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
